import { useEffect, useRef, useState } from "react";
import i18n from "../../i18n";

// Canvas توقيع بارتفاع مخصّص — يستخدم أبعاداً ديناميكية لضمان أن رسمة الإصبع تظهر تحت المؤشر تماماً.
export const SignatureCanvas = ({ onChange, color = "#0F172A", height = 260 }) => {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const canvas = ref.current;
    const resize = () => {
      const dpr = window.devicePixelRatio || 1;
      const w = canvas.getBoundingClientRect().width || 320;
      canvas.width = Math.floor(w * dpr);
      canvas.height = Math.floor(height * dpr);
      canvas.style.height = `${height}px`;
      const ctx = canvas.getContext("2d");
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.lineWidth = 3;
      ctx.strokeStyle = color;
      ctx.lineCap = "round";
      ctx.lineJoin = "round";
    };
    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, [color, height]);

  const pos = (e) => {
    const rect = ref.current.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    return { x: t.clientX - rect.left, y: t.clientY - rect.top };
  };
  const start = (e) => { drawing.current = true; const { x, y } = pos(e); const c = ref.current.getContext("2d"); c.beginPath(); c.moveTo(x, y); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault?.(); const { x, y } = pos(e); const c = ref.current.getContext("2d"); c.lineTo(x, y); c.stroke(); setEmpty(false); };
  const end = () => { drawing.current = false; onChange?.(ref.current.toDataURL("image/png")); };
  const clear = () => {
    const c = ref.current.getContext("2d");
    c.clearRect(0, 0, ref.current.width, ref.current.height);
    setEmpty(true);
    onChange?.(null);
  };

  return (
    <div className="space-y-2">
      <canvas ref={ref} data-testid="signature-canvas"
        className="block w-full max-w-full touch-none rounded-2xl border-2 border-neutral-300 bg-white shadow-inner"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end}
      />
      <button type="button" onClick={clear} disabled={empty} data-testid="clear-sig"
              className="rounded-lg border border-neutral-300 bg-white px-3 py-1 text-xs font-bold text-neutral-700 hover:bg-neutral-50 disabled:opacity-40">
        {i18n.t("app.clear")}
      </button>
    </div>
  );
};
